/**
 * 链上U谷 业务配置
 * */
// const env = process.env.NODE_ENV;
var Setting = {
  /**
   * 基础配置
   * */
  headTheme: 'darkBlue',
  // 网页标题的后缀
  titleSuffix: '链上U谷',
  // 路由模式，可选值为 history 或 hash
  routerMode: 'hash',
  // 应用的基路径
  routerBase: '/',
  // 页面切换时，是否显示模拟的进度条
  showProgressBar: true,
  // 接口请求地址
  apiBaseURL: process.env.VUE_APP_HOST,
  // apiBaseURL: env === 'development' ? '/' : '/', // 备注：保留此行，备份
  // 接口请求返回错误时，弹窗的持续时间，单位：秒
  modalDuration: 3,
  // 接口请求返回错误时，弹窗的类型，可选值为 Message 或 Notice
  errorModalType: 'Notice',
  // Cookies 默认保存时间，单位：天
  cookiesExpires: 1,

  /**
   * 多语言配置
   * */
  i18n: {
    // 默认语言
    default: 'zh-CN',
    // 是否根据用户电脑配置自动设置语言（仅第一次有效）
    auto: false
  },

  /**
   * 布局配置
   * */
  // 侧边菜单宽度，单位 px，不可动态修改，需与 setting.less 的 @menuSideWidth 保持一致
  layout: {
    layoutTheme: localStorage.getItem('theme') || 'darkBlue',
    // 框架主体 darkBlue
    // 是否开启多 Tabs 页签
    tabs: true,
    // 是否固定多 Tabs 多页签
    tabsFix: true,
    // 再次点击 Tabs 页签时，是否重载当前页面
    tabsReload: false,
    // 页签是否支持拖拽排序
    tabsOrder: false
  },

  /**
   * 多页 Tabs
   * */
  page: {
    // 默认打开的页签
    opened: []
  },

  /**
   * 功能配置
   * */
  // 相同路由，不同参数间进行切换，是否强力更新
  sameRouteForceUpdate: false,
  // 是否使用动态侧边菜单
  dynamicSiderMenu: false
};
export default Setting;